module.exports = __webpack_public_path__ + "media/images/app-icon-05f5b5cc0dcd1b39fbe6e555c8c7fdc9.svg";